import React, { useEffect } from 'react';
import Pages from './Pages';
import {Provider} from 'react-redux';
import {store} from './store/store';

export const App = (): JSX.Element => {

  useEffect(() => {
    console.log("new maintenance timeline fa loaded");
    console.log('React.version', React.version);
  }, []);

  return (
    <Provider store={store}>
      <Pages />
    </Provider>
  );
};
